module.exports = __webpack_public_path__ + "static/img/023 1.b529191e.jpg";